import axios from 'axios';
import { API_BASE_URI } from 'library/constants/api';
import type { CancellationPolicyTemplate } from '../features/placeSlice';

const BASE = `${API_BASE_URI}/property`;

function authHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` };
}

export async function getCatalog(): Promise<CancellationPolicyTemplate[]> {
  const res = await axios.get(`${BASE}/cancellation-policy/catalog`, { headers: authHeaders() });
  return (res?.data?.result ?? []) as CancellationPolicyTemplate[];
}
